import React, {useState, useEffect} from 'react';
import { useStyles } from "./style";
import {Grid} from '@material-ui/core/';
import ComponenteParaVisualizarOCargarDocumentoPDFFallecidos from 'components/CustomDialog';
import Title from 'components/TitleWithIcon';
import Form from 'components/Form/FormTwoColumns';
import { AccountCircle, Wc, Search, Today, Room, Person } from '@material-ui/icons/';
import DialogLoadingMessage from 'components/LoadingMessage'
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import ApiServices from 'services/ApiServices';
import DatosBasicosDelFallecido from './DatosDelFallecido'
import TablaTransaccionalDelFallecido from './TablaTransaccionalDelFallecido'
import ComponenteDeFormularioParaHabilitacionDeFallecidos from './Formulario'

function HabilitacionDeFallecidos(props) {
    const classes = useStyles()
    const [loadingMessage, setLoadingMessage] = useState({ loading: false, title: '' })
    const [datosPadron, setDatosPadron] = useState('');
    const [tablaTransaccional, setTablaTransaccional] = useState('');

    const keyPress = async (event) => {
        if (event.key === "Enter" && elements.nroBoleta.value) {
            EjecutarFuncionesDeBusqueda()
        }
        };

    const EjecutarFuncionesDeBusqueda = () => {
        ConsultarDataPadron()        
    }        
    const ConsultarDataPadron = async () => {
        setLoadingMessage({ loading: true, title: 'Consultando información ... ' })

        try {
            let response = await ApiServices.habilitacion.consultarPadron(elements.nroBoleta.value);
            if (response.error) {
                showMessagePersonalizedPosition('error', '¡Oopss!', response.error.message)
            } else {
                setDatosPadron(response.data)
            }
        } catch (exception) {
            if (exception.status === 404) {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
        }
        setLoadingMessage({ loading: false, title: '' })
    }

    const ConsultandoTablaTransaccional = async () => {
        setLoadingMessage({ loading: true, title: 'Consultando tabla transaccional ... ' })

        try {
            let responseTable = await ApiServices.habilitacion.list(elements.nroBoleta.value);
            if (responseTable.error) {
                showMessagePersonalizedPosition('error', '¡Oopss!', responseTable.error.message)
            } else {
                setTablaTransaccional(responseTable.data)
            }
        } catch (exception) {
            if (exception.status === 404) {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
        }
        setLoadingMessage({ loading: false, title: '' })
    }

    useEffect(() => {
        if(datosPadron){
            ConsultandoTablaTransaccional()
        }
    }, [datosPadron])
    const [elements, setElements] = useState({
        nroBoleta: {
            idelement: "nroBoleta",  value:'', label: "Ingrese No. boleta *", pattern:"^[0-9]{2,13}$", disabled: false, keyPress: keyPress,
            validators: ['required'], errorMessages:['Ingrese No. boleta, sin espacios al inicio y final'], isError:false, elementType:'input',
        },
    })    
    const [buttonList] = React.useState({
        "functionSaveData": {
            "label": "Buscar", "icon": <Search />, "callback": EjecutarFuncionesDeBusqueda, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border": "0px", "borderRadius": "3", IsButtonCancelar:false,
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: false, sendWithoutValidForm: true
        },
    });

    return (
        <ComponenteParaVisualizarOCargarDocumentoPDFFallecidos 
            titleToolbar={props.titleToolbar}
            iconToolbar={props.iconToolbar}
            open={props.open}
            fullScreen={props.fullScreen}
            closeModal={props.closeModal}
            actualizarTabla={props.actualizarTabla}
        >          
            <div id="scroller" >
                <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title} />
                {/* <Title title="Habilitación de fallecidos" icon={"/menu/Document.png"}/> */}
                <div className={classes.colorComponente}>
                    <Grid >
                        <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center">
                            <Form elements= {elements}  buttonList={buttonList} />
                        </Grid>                
                    </Grid><br/>
                    <div className={classes.lineaDegradadaBottom}></div>
                </div>            
                <DatosBasicosDelFallecido datosPadron={datosPadron}/>
                <TablaTransaccionalDelFallecido tablaTransaccional={tablaTransaccional}/>
                <ComponenteDeFormularioParaHabilitacionDeFallecidos datosPadron={datosPadron} closeModal={props.closeModal} nroboleta={elements.nroBoleta.value} actualizarTabla={props.actualizarTabla}/>
                <br/>
            </div>
        </ComponenteParaVisualizarOCargarDocumentoPDFFallecidos>
    );
}


export default HabilitacionDeFallecidos;